import React from 'react';
import {Image} from '@shopify/hydrogen';
import {Popover} from '@headlessui/react';
import * as Portal from '@radix-ui/react-portal';
import {useMatches, useLoaderData} from '@remix-run/react';
import type {
  Product,
  ProductVariant,
  Collection,
  Metafield,
} from '@shopify/hydrogen/storefront-api-types';
//domains
import type {SanityProductQueryResponse} from '~/domains/product';

//components
import SanityImage from 'components/SanityImage';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';

interface BrandWithMetafeilds extends Pick<Collection, 'title' | 'id'> {
  is_brand?: Metafield;
  size_chart?: Metafield;
  shipping_status?: Metafield;
}

export default function ProductDetailsSizeGuide() {
  const matches = useMatches();
  const routeData = matches.find(
    (m) => m.id === 'routes/($lang)/products/$productHandle',
  )?.data;
  const sizeGuide =
    routeData.sizeGuide as SanityProductQueryResponse['sizeGuide'];
  const productSettings =
    routeData.productSettings as SanityProductQueryResponse['productSettings'];
  // const product = routeData.product as Product & {
  //   selectedVariant?: ProductVariant;
  // };
  const selectedSizeGuide =
    sizeGuide?.brand_size_guide ??
    productSettings.product_settings_main.default_size_guide;

  const {product} = useLoaderData<typeof loader>();
  const collections = product?.collections?.nodes as BrandWithMetafeilds[];
  const brand = collections?.find((c) => {
    return c?.is_brand?.value === 'true';
  });
  return (
    <div className="order-1 w-[114px] self-end lg:order-2 lg:self-center">
      <div className="">
        {brand?.is_brand && brand.size_chart && (
          <Popover>
            {({open}) => (
              <>
                <Popover.Button className="flex items-center space-x-1 border border-black p-1 outline-none">
                  <div className="w-6">
                    {productSettings.product_settings_main.size_guide_icon && (
                      <SanityImage
                        layout="responsive"
                        sizes={['50vw, 100vw']}
                        src={
                          productSettings.product_settings_main.size_guide_icon
                            ?.asset._ref
                        }
                        className="h-full object-cover"
                      />
                    )}
                  </div>

                  <span className="whitespace-nowrap text-xs font-normal">
                    {productSettings.product_settings_main.size_guide_label ??
                      'Size Guide'}
                  </span>
                </Popover.Button>
                <Portal.Root>
                  <Popover.Panel className="fixed left-0 top-0 z-[100] py-5 px-4 flex h-full w-full items-center justify-center overflow-y-scroll bg-black bg-opacity-20">
                    <div className="relative h-full bg-white">
                      <Popover.Button className="absolute top-0 right-0 -translate-x-3 translate-y-3 text-black">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.5 9.35849L1.85849 15L0 13.1415L5.64151 7.5L0 1.85849L1.85849 0L7.5 5.64151L13.1415 0L15 1.85849L9.35849 7.5L15 13.1415L13.1415 15L7.5 9.35849Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Popover.Button>
                      {brand.size_chart && (
                        <div className="w-full md:w-[70vw] py-5">
                          <Image data={{url: brand.size_chart.value ?? ''}} />
                        </div>
                      )}
                      {/* {selectedSizeGuide && (
                        <SanityImage
                          layout="responsive"
                          sizes={['50vw, 100vw']}
                          src={selectedSizeGuide?.asset._ref}
                          className="h-full object-cover"
                        />
                      )} */}
                    </div>
                  </Popover.Panel>
                </Portal.Root>
              </>
            )}
          </Popover>
        )}
      </div>
    </div>
  );
}
